import React, { useRef, useEffect } from "react";
import "../assets/css/academy.css";
import DATA from "../components/Data";
import Card from "../components/Card";
import Hero from "../components/Hero";
import { useLocation } from "react-router-dom";
import FinAidGif from "../assets/videos/fin_ad-onboard-1.gif"; // ✅ import gif
import communityGif from "../assets/videos/community.mp4";

const Academy = () => {
  const middleRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash === "#academy") {
      middleRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <Hero middleRef={middleRef} />
      <div id="academy" ref={middleRef} className="container">
        <h1>Boost Your Skills: Enroll in Our Brief Bootcamp Today</h1>
        <div className="grid">
          {DATA.map((item) => (
            <Card data={item} key={item.id} />
          ))}
        </div>

        {/* 🎯 Financial Aid Section */}
        <div className="financial-aid-section">
          <div className="aid-gif">
            <img src={FinAidGif} alt="Financial Aid Process" />
          </div>
          <div className="aid-text">
            <h2>Limited Financial Aid Slots Available!</h2>
            <p>
              We believe everyone deserves access to quality tech education. If
              finances are a concern, don’t worry – apply for a financial aid
              slot today.
            </p>
            {/* <button className="btn">Apply for Financial Aid</button> */}
          </div>
        </div>

        {/* community section */}
        <div className="community-section-container">
          <div className="community-row">
            <div className="community-col">
              <h2>Join Our Free Community: Learn, Grow, and Thrive in Tech</h2>
              <p>
                Connect with fellow newbies and pros in our free community. Get
                support, resources, and guidance to kickstart your tech journey.
                Share experiences, ask questions, and learn from others. Start
                your path to a successful tech career today!
              </p>

              <a
                href="https://chat.whatsapp.com/G1SxPH8JAq58JpjupbQGEg"
                target="_blank"
                rel="noopener noreferrer"
                className="btn5"
              >
                Join Our Community
              </a>
            </div>
          </div>
          <div className="community-image">
            <video muted autoPlay loop>
              <source src={communityGif} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </>
  );
};

export default Academy;
